<template>
    <div class="review-item">

        <div class="is-flexy is-middle">

            <div class="rating-component">

                <div class="stars" :style="{width: calculateSize, marginRight: difference}"></div>

                <div class="rating-info" style="float: right;">{{ data.metrics.rating }}.0</div>

            </div>

            <h4>{{ data.details.headline}}</h4>

            <span class="by-from">By <span>{{ data.details.nickname }}</span> from <span>{{ data.details.location }}</span></span>

        </div>

        <p>{{ data.details.comments }}</p>

    </div>

</template>

<script>

import ratingComponent from '../shared/rating.vue'

export default  {

  name: 'review-item',

  props: ['data'], // review date coming from parent component

  components:{ ratingComponent },

  computed:{

    calculateSize(){

      return this.data.metrics.rating * 70 / 5 + 'px';

    },

    difference(){

      return 70 - this.data.metrics.rating * 70 / 5 + 'px';

    }

  }

}

</script>


<style scoped lang="scss">

    .review-item{

        float: left;
        width: 100%;
        padding-bottom: 26px;
        margin-bottom: 30px;

        border-bottom: 1px solid #E8E8E8;

        h4{ margin: 0 0 0 15px;}

        .by-from{

            float: left;
            width: 100%;
            font-family: sofiapro-light;
            font-size: 14px;
            font-weight: 100;
            line-height: 16px;
            margin-top: 10px;
            color: #747678;

            span{
                color: #B1CDEB;
            }

        }

    }

</style>


// WEBPACK FOOTER //
// src/components/reviews/review-item.vue